import { useEffect, useState } from "react";

import { cn } from "@/shared/lib/css";

interface DepositCountdownProps {
  expiresAt: string;
  className?: string;
}

export function DepositCountdown({
  expiresAt,
  className,
}: DepositCountdownProps) {
  const [timeLeft, setTimeLeft] = useState<string | null>(null);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const expiry = new Date(expiresAt).getTime();
      const diff = expiry - now;

      if (diff <= 0) {
        setIsExpired(true);
        return null; // Don't show if expired
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (hours > 24) {
        const days = Math.floor(hours / 24);
        return `${days}д ${hours % 24}ч`;
      }

      if (hours > 0) {
        return `${hours}ч ${minutes}м`;
      }

      return `${minutes}м ${seconds}с`;
    };

    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [expiresAt]);

  if (isExpired || !timeLeft) {
    return null;
  }

  return (
    <div className={cn("text-xs text-muted-foreground", className)}>
      Истекает: {timeLeft}
    </div>
  );
}
